import { render, staticRenderFns } from "./QueryHeader.vue?vue&type=template&id=31ca64b3&scoped=true"
import script from "./QueryHeader.vue?vue&type=script&lang=js"
export * from "./QueryHeader.vue?vue&type=script&lang=js"
import style0 from "./QueryHeader.vue?vue&type=style&index=0&id=31ca64b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca64b3",
  null
  
)

export default component.exports